import React from 'react';
import Navigation from '../../components/navigation';
import Banner from '../../components/banner';
import Footer from '../../components/footer';
import pic1 from '../../public/images/recruitment/recruitment-pic-1.png';
import pic2 from '../../public/images/recruitment/recruitment-pic-2.png';
import pic3 from '../../public/images/recruitment/recruitment-pic-3.png';
import pic4 from '../../public/images/recruitment/recruitment-pic-4-5.png';
import pic5 from '../../public/images/recruitment/recruitment-pic-5.png';
import pic6 from '../../public/images/recruitment/recruitment-pic-6.png';
import pic7 from '../../public/images/recruitment/recruitment-pic-7.png';
import pic8 from '../../public/images/recruitment/recruitment-pic-8-1.png';

function App() {
  // 导航配置
  return (
    <div className="app">
      <Navigation active={1} />
      <Banner />
      <div className="main-container">
        <div className="main-inner">
          <img className={'pic-1'} src={pic1} alt="" />
          <img className={'pic-2'} src={pic2} alt="" />
          <img className={'pic-3'} src={pic3} alt="" />
          <img className={'pic-4'} src={pic4} alt="" />
          <img className={'pic-5'} src={pic5} alt="" />
          <img className={'pic-6'} src={pic6} alt="" />
          <img className={'pic-7'} src={pic7} alt="" />
          <img className={'pic-8'} src={pic8} alt="" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;